import { v4 as uuid } from 'uuid';
import { encounterIdB } from '../encounters';
import { Order, OrderType } from '@getvim-os/types';

export const orderB: Order = {
  id: uuid(),
  type: OrderType.LAB,
  icd: [],
  cpts: [{ name: 'Mastectomy gynecomastia', code: '19300' }],
  encounterId: encounterIdB,
  createdDate: '2000-01-01',
};
